import cn from 'classnames'

export const avatarGroupContainerClassName = cn(
   'relative flex flex-row justify-start items-center'
)

export const avatarWrapperClassName = cn(
   'relative flex flex-row justify-start items-center p-4px bg-white'
)

export const avatarCountContainerClassName = cn(
   `flex justify-center items-center `
)

export const avatarCounterWrapper = cn('p-4px bg-white')
export const avatarCountTextClassName = cn(`text-gray-600 font-medium`)

export const avatarFocusClassName = cn(`bg-primary-100`)
